<template>
  <div>
    <!--------------section one--------------->
    <v-row>
      <v-col cols="12" md="4" sm="12">
        <div class="d-flex justify-start">
          <h1 class="heading-1">Dashboard</h1>
        </div>
      </v-col>
      <v-col cols="12" md="8" sm="12">
        <v-card flat class="d-flex align-center justify-end pt-2zxccvv">
          <div class="mr-7 d-flex">
            <v-icon class="mx-3"> mdi-account-group </v-icon>
            <div style="padding-top: 4px">
              <span>Live Users: </span>
              <span class="blue--text"><b>6.25k </b></span>
            </div>
          </div>
          <v-card class="pa-1 mr-6" elevation="4"
            ><svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 20C2 21.1046 2.89543 22 4 22H17.4142L22 17.4142V4C22 2.89543 21.1046 2 20 2H4C2.89543 2 2 2.89543 2 4V20ZM4 4H20V15H17C15.8954 15 15 15.8954 15 17V20H4V4ZM17 17H19.5858L17 19.5858V17ZM7 15V17H13V15H7ZM7 13V11H17V13H7ZM7 7V9H17V7H7Z"
                fill="#222222"
                fill-opacity="0.7"
              />
            </svg>
          </v-card>
          <v-card elevation="4" style="width: auto">
            <!-- <date-picker v-model="time1" range></date-picker> -->
            <!-- <v-select
              :items="filterItem"
              single-line
              solo
              flat
              prepend-inner-icon="mdi-calendar-today"
              label="This month"
              hide-details=""
            >
            </v-select> -->
            <b-dropdown variant="transparent">
              <template #button-content>
                <v-icon>mdi-calendar-today</v-icon>
                <span class="mx-3"><b> This month </b></span>
              </template>
              <b-dropdown-item
                varient="transparent"
                v-for="(item, i) in filterItem"
                :key="i"
                ><span style="color: black">
                  {{ item.text }}</span
                ></b-dropdown-item
              >
            </b-dropdown>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <!--------------section Two--------------->
    <div class="mt-4">
      <v-card flat><h3 class="h2">Membership numbers</h3></v-card>
      <v-row>
        <v-col cols="12" md="3" sm="6">
          <!-- <v-card class="pa-5" outlined flat>
            <p><b class="card_h1"> New members</b></p>
            <v-card flat class="d-flex">
              <h3 class="card_span_one">5.25k</h3> -->
          <!--------------------new member dialoag ------------------->
          <v-dialog v-model="NewMemberdialog" max-width="1019px">
            <template v-slot:activator="{ on, attrs }">
              <v-card class="pa-5" v-on="on" outlined flat>
                <p><b class="card_h1" v-on="on"> New members</b></p>
                <v-card
                  flat
                  class="d-flex"
                  color="transparent"
                  v-bind="attrs"
                  v-on="on"
                >
                  <h3 class="card_span_one">5.25k</h3>
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </v-card>
                <div>
                  <p class="mb-0 month_span" style="color: #a1a1a6">
                    Last month: 4.25k
                  </p>
                </div>
              </v-card>
            </template>
            <v-card>
              <div>
                <newnemberlinechart-component />
              </div>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col cols="12" md="3" sm="6">
          <!-------------------- member Renewals dialoag ------------------->
          <v-dialog v-model="memberrenewalsdialog" max-width="1019px">
            <template v-slot:activator="{ on, attrs }">
              <v-card class="pa-5" v-on="on" outlined flat>
                <p><b class="card_h1" v-on="on">Member renewals</b></p>
                <v-card
                  flat
                  class="d-flex"
                  color="transparent"
                  v-bind="attrs"
                  v-on="on"
                >
                  <h3 class="card_span_one">5.25k</h3>
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </v-card>
                <div>
                  <p class="mb-0 month_span" style="color: #a1a1a6">
                    Last month: 4.25k
                  </p>
                </div>
              </v-card>
            </template>
            <v-card>
              <div>
                <memberrenewalslinechart-component />
              </div>
            </v-card>
          </v-dialog>
          <!-- <v-card class="pa-5"  outlined flat>
            <p><b class="card_h1"> Member renewals</b></p>
            <v-card flat class="d-flex">
              <h3>5.25k</h3>
              <v-dialog v-model="memberrenewalsdialog" max-width="1019px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </template>
                <v-card>
                  <div>
                    <memberrenewalslinechart-component />
                  </div>
                </v-card>
              </v-dialog>
            </v-card>
            <div>
              <p class="mb-0 month_span" style="color: #a1a1a6">
                Last month: 4.25k
              </p>
            </div>
          </v-card> -->
        </v-col>
        <v-col cols="12" md="3" sm="12">
          <!-------------------Member expired dialoag ------------------->
          <v-dialog v-model="memberexpireddialog" max-width="1019px">
            <template v-slot:activator="{ on, attrs }">
              <v-card class="pa-5" v-on="on" outlined flat>
                <p><b class="card_h1" v-on="on">Members expired</b></p>
                <v-card
                  flat
                  class="d-flex"
                  color="transparent"
                  v-bind="attrs"
                  v-on="on"
                >
                  <h3 class="card_span_one">5.25k</h3>
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </v-card>
                <div>
                  <p class="mb-0 month_span" style="color: #a1a1a6">
                    Last month: 4.25k
                  </p>
                </div>
              </v-card>
            </template>
            <v-card>
              <div>
                <memberexpiredlinechart-component />
              </div>
            </v-card>
          </v-dialog>
          <!-- <v-card class="pa-5" outlined flat>
            <p><b class="card_h1"> Member expired</b></p>
            <v-card flat class="d-flex">
              <h3>5.25k</h3>
              <v-dialog v-model="memberexpireddialog" max-width="1019px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </template>
                <v-card>
                  <div>
                    <memberexpiredlinechart-component />
                  </div>
                </v-card>
              </v-dialog>
            </v-card>
            <div>
              <p class="mb-0 month_span" style="color: #a1a1a6">
                Last month: 4.25k
              </p>
            </div>
          </v-card> -->
        </v-col>
        <v-col cols="12" md="3" sm="12"></v-col>
      </v-row>
    </div>
    <!--------------section Three- pie chart-------------->
    <div class="mt-9">
      <v-row>
        <v-col cols="12" md="6">
          <v-card class="pa-5" flat outlined>
            <p class="mb-2"><b class="card_h1"> Total members</b></p>
            <span class="card_span_one">5.25k</span>
            <div class="d-flex justify-start">
              <!----------------------chart component-------------------------------------------->
              <v-row class="">
                <v-col cols="12" md="4" sm="4"><piechart-component /></v-col>
                <v-col cols="12" md="6" sm="6">
                  <div class="mt-6">
                    <v-row>
                      <v-col class="pa-1" cols="12" md="6" sm="6"
                        ><div class="d-flex align-center">
                          <v-card
                            flat
                            color="#0071BD"
                            width="13"
                            class="pie_dot"
                            height="13"
                          ></v-card>
                          <span class="pie_text">500 Starter</span>
                        </div>
                      </v-col>
                      <v-col class="pa-1" cols="12" md="6" sm="6"
                        ><div class="d-flex align-center">
                          <v-card
                            flat
                            color="#F4685F"
                            width="13"
                            class="pie_dot"
                            height="13"
                          ></v-card>
                          <span class="pie_text">500 Practitionerr</span>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pa-1" cols="12" md="6" sm="6"
                        ><div class="d-flex align-center">
                          <v-card
                            flat
                            color="#EAA413"
                            width="13"
                            class="pie_dot"
                            height="13"
                          ></v-card>
                          <span class="pie_text">400 Access</span>
                        </div>
                      </v-col>
                      <v-col class="pa-1" cols="12" md="6" sm="6"
                        ><div class="d-flex align-center">
                          <v-card
                            flat
                            color="#22C4E7"
                            width="13"
                            class="pie_dot"
                            height="13"
                          ></v-card>
                          <span class="pie_text">500 Practitioner</span>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pa-1" cols="12" md="6" sm="12"
                        ><div class="d-flex align-center">
                          <v-card
                            flat
                            color="#B4E722"
                            width="13"
                            class="pie_dot"
                            height="13"
                          ></v-card>
                          <span class="pie_text">400 Standard</span>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>

              <!---------------------end-chart component-------------------------------------------->
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card flat outlined>
            <chartdashboard />
          </v-card>
        </v-col>
      </v-row>
    </div>
    <!--------------section four--------------->
    <div class="mt-9">
      <h1 class="h2">Sales</h1>
      <v-row>
        <v-col cols="12" md="4" sm="6">
          <!-------------------Total manuals of books sales dialoag ------------------->
          <v-dialog v-model="booksaleseddialog" max-width="1019px">
            <template v-slot:activator="{ on, attrs }">
              <v-card class="pa-5" v-on="on" outlined flat>
                <p>
                  <b class="card_h1" v-on="on">Course and manual Sales</b>
                </p>
                <v-card
                  flat
                  class="d-flex"
                  color="transparent"
                  v-bind="attrs"
                  v-on="on"
                >
                  <h3 class="card_span_one">5.25k</h3>
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </v-card>
                <div>
                  <p class="mb-0 month_span" style="color: #a1a1a6">
                    Last month: 4.25k
                  </p>
                </div>
              </v-card>
            </template>
            <v-card>
              <div>
                <booksaleslinechart-component />
              </div>
            </v-card>
          </v-dialog>
          <!-- <v-card class="pa-5" outlined flat>
            <p><b class="card_h1"> Total manuals of books sales</b></p>
            <v-card flat class="d-flex">
              <h3>5.25k</h3>
              
              <v-dialog v-model="booksaleseddialog" max-width="1019px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </template>
                <v-card>
                  <div>
                    <booksaleslinechart-component />
                  </div>
                </v-card>
              </v-dialog>
            </v-card>
            <div>
              <p class="mb-0 month_span" style="color: #a1a1a6">
                Last month: 4.25k
              </p>
            </div>
          </v-card> -->
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <v-card class="pa-5 pb-8" outlined flat>
            <p><b class="card_h1">Top two manuals sold</b></p>
            <div>
              <span class="font--16"
                >1. [name_manual_of_course]
                <span class="month_span" style="color: #a1a1a6">
                  - 757 sales</span
                ></span
              >
              <div>
                <span class="font--16"
                  >2. [name_manual_of_course]
                  <span class="month_span" style="color: #a1a1a6">
                    - 127 sales</span
                  ></span
                >
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" sm="6">
          <v-card class="pa-5 pb-8" outlined flat>
            <p><b class="card_h1">Top two courses sold</b></p>
            <div>
              <span class="font--16"
                >1. [name_manual_of_course]
                <span class="month_span" style="color: #a1a1a6">
                  - 757 sales</span
                ></span
              >
              <div>
                <span class="font--16"
                  >2. [name_manual_of_course]
                  <span class="month_span" style="color: #a1a1a6">
                    - 127 sales</span
                  ></span
                >
              </div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" md="4" sm="6">
          <v-card class="pa-5 pb-8" outlined flat>
            <p><b class="card_h1">Top two products sold (not manual)</b></p>
            <div>
              <div>
                <span class="font--16"
                  >1. What is BodyTalk Brochure
                  <span class="month_span" style="color: #a1a1a6">
                    - 757 sales</span
                  ></span
                >
              </div>
              <div>
                <span class="font--16"
                  >2. BodyTalk Pens
                  <span class="month_span" style="color: #a1a1a6">
                    - 127 sales</span
                  ></span
                >
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div class="mt-9">
      <h1 class="h2">Total Sales</h1>
      <v-row>
        <v-col cols="12" md="3" sm="6" class="mt-4">
          <v-card class="pa-2" outlined flat>
            <p class="card-h2 mb-0">Today: $5,675</p>
            <p class="card-h2 mb-0">Month to date: $15,500</p>
            <p class="card-h2 mb-0">Month total previous year: $18,000</p>
            <p class="card-h2 mb-0">Last month total: $18,000</p>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <!--------------section five--------------->
    <div class="mt-9">
      <v-card flat><h3 class="h2">Student numbers</h3></v-card>
      <v-row class="mt-3">
        <v-col cols="12" md="3" sm="6">
          <!-------------------Registered students who attended dialoag ------------------->
          <v-dialog v-model="registerstudentdialog" max-width="1019px">
            <template v-slot:activator="{ on, attrs }">
              <v-card class="pa-5" v-on="on" outlined flat>
                <p>
                  <b class="card_h1" v-on="on">Course registrations</b>
                </p>
                <v-card
                  flat
                  class="d-flex"
                  color="transparent"
                  v-bind="attrs"
                  v-on="on"
                >
                  <h3 class="card_span_one">5.25k</h3>
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </v-card>
                <div>
                  <p class="mb-0 month_span" style="color: #a1a1a6">
                    Last month: 4.25k
                  </p>
                </div>
              </v-card>
            </template>
            <v-card>
              <div>
                <registerstudentlinechart-component />
              </div>
            </v-card>
          </v-dialog>
          <!-- <v-card class="pa-5" outlined flat>
            <p><b class="card_h1"> Registered students who attended</b></p>
            <v-card flat class="d-flex">
              <h3>5.25k</h3>
              
              <v-dialog v-model="registerstudentdialog" max-width="1019px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </template>
                <v-card>
                  <div>
                    <registerstudentlinechart-component />
                  </div>
                </v-card>
              </v-dialog>
            </v-card>
            <div>
              <p class="mb-0 month_span" style="color: #a1a1a6">
                Last month: 4.25k
              </p>
            </div>
          </v-card> -->
        </v-col>
        <v-col cols="12" md="3" sm="6">
          <!-------------------Graduating students who attended dialoag ------------------->
          <v-dialog v-model="Graduatestudentdialog" max-width="1019px">
            <template v-slot:activator="{ on, attrs }">
              <v-card class="pa-5" v-on="on" outlined flat>
                <p>
                  <b class="card_h1" v-on="on"> Course graduation</b>
                </p>
                <v-card
                  flat
                  class="d-flex"
                  color="transparent"
                  v-bind="attrs"
                  v-on="on"
                >
                  <h3 class="card_span_one">5.25k</h3>
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </v-card>
                <div>
                  <p class="mb-0 month_span" style="color: #a1a1a6">
                    Last month: 4.25k
                  </p>
                </div>
              </v-card>
            </template>
            <v-card>
              <div>
                <graduatestudentlinechart-component />
              </div>
            </v-card>
          </v-dialog>
          <!-- <v-card class="pa-5" outlined flat>
            <p><b class="card_h1"> Graduating students who attended</b></p>
            <div class="d-flex">
              <h3>5.25k</h3>
             
              <v-dialog v-model="Graduatestudentdialog" max-width="1019px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </template>
                <v-card>
                  <div>
                    <graduatestudentlinechart-component />
                  </div>
                </v-card>
              </v-dialog>
            </div>
            <div>
              <p class="mb-0 month_span" style="color: #a1a1a6">
                Last month: 4.25k
              </p>
            </div>
          </v-card> -->
        </v-col>
      </v-row>
    </div>
    <div class="mt-8">
      <div>
        <b> <p class="mt-2 h2">Practitioner/Instructor numbers</p></b>
      </div>
      <v-row>
        <v-col cols="12" md="6" sm="6">
          <v-card class="pa-3" outlined flat>
            <!-- <b> <p class="card_h1 mt-2">Practitioner/Instructor numbers</p></b> -->
            <p class="card-h2 mb-0">
              Total CBPs: 1265 (must be paid active member)
            </p>
            <p class="card-h2 mb-0">
              Total Instructors: 348 (must be paid active member)
            </p>
            <p class="card-h2 mb-0">
              Total Countries Taught in: 61 (total # of countries where a course
              has been)
            </p>
            <p class="card-h2 mb-0">
              Total Languages Taught in: 10 (total # of languages a course has
              been taught in)
            </p>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <!--------------section six--------------->
    <div class="mt-9">
      <v-card flat><h3 class="h2">Site Traffic</h3></v-card>
      <v-row>
        <v-col cols="12" md="3" sm="6">
          <!-------------------Traffic dialoag ------------------->
          <v-dialog v-model="trafficdialog" max-width="1019px">
            <template v-slot:activator="{ on, attrs }">
              <v-card class="pa-5" v-on="on" outlined flat>
                <p>
                  <b class="card_h1" v-on="on">Visits</b>
                </p>
                <v-card
                  flat
                  class="d-flex"
                  color="transparent"
                  v-bind="attrs"
                  v-on="on"
                >
                  <h3 class="card_span_one">5.25k</h3>
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </v-card>
                <div>
                  <p class="mb-0 month_span" style="color: #a1a1a6">
                    Last month: 4.25k
                  </p>
                </div>
              </v-card>
            </template>
            <v-card>
              <div>
                <trafficlinechart-component />
              </div>
            </v-card>
          </v-dialog>
          <!-- <v-card class="pa-5" outlined flat>
            <p><b class="card_h1"> Visits</b></p>
            <v-card flat class="d-flex">
              <h3>5.25k</h3>
              
              <v-dialog v-model="trafficdialog" max-width="1019px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="transparent"
                    class="pa-0"
                    depressed
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div class="d-flex">
                      <div class="mx-2" style="margin-top: 2px">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.66536 0L11.192 1.52667L7.9387 4.78L5.27203 2.11333L0.332031 7.06L1.27203 8L5.27203 4L7.9387 6.66667L12.1387 2.47333L13.6654 4V0H9.66536Z"
                            fill="#27AE60"
                          />
                        </svg>
                      </div>

                      <p class="my-1 card_span_two">+555.75%</p>
                    </div>
                  </v-btn>
                </template>
                <v-card>
                  <div>
                    <trafficlinechart-component />
                  </div>
                </v-card>
              </v-dialog>
            </v-card>
            <div>
              <p class="mb-0 month_span" style="color: #a1a1a6">
                Last month: 4.25k
              </p>
            </div>
          </v-card> -->
        </v-col>
      </v-row>
    </div>
    <!--------------section table--------------->
    <div class="my-9">
      <span class="table-heading">Page visits</span>
      <div class="mt-6">
        <v-card outlined flat>
          <v-data-table
            :headers="headers"
            :items="dashboardDataTable"
            :items-per-page="5"
            :loading="tableLoader"
            loading-text="Loading... Please wait"
          >
            <template v-slot:[`item.index`]="{ item }">
              <b class="table_style_one"> {{ item.index }} </b>
            </template>
            <template v-slot:[`item.page`]="{ item }">
              <p class="mb-0 mx-3 table_style_one">
                {{ item.page }}
              </p>
            </template>
            <template v-slot:[`item.slug`]="{ item }">
              <span class="table_style_two"> {{ item.slug }} </span>
            </template>
            <template v-slot:[`item.visit`]="{ item }">
              <span class="table_style_two"> {{ item.visit }} </span>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
//import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import BooksaleslinechartComponent from "../../components/dashoard/booksaleslinechart.component.vue";
import GraduatestudentlinechartComponent from "../../components/dashoard/graduatestudentlinechart.component.vue";
import MemberexpiredlinechartComponent from "../../components/dashoard/memberexpiredlinechart.component.vue";
import MemberrenewalslinechartComponent from "../../components/dashoard/memberrenewalslinechart.component.vue";
import NewnemberlinechartComponent from "../../components/dashoard/newnemberlinechart.component.vue";
import PiechartComponent from "../../components/dashoard/piechart.component.vue";
import RegisterstudentlinechartComponent from "../../components/dashoard/registerstudentlinechart.component.vue";
import TrafficlinechartComponent from "../../components/dashoard/trafficlinechart.component.vue";
import chartdashboard from "../../components/dashoard/chartdashboard.component.vue";
import { mapGetters } from "vuex";
export default {
  name: "dashboard",
  components: {
    //DatePicker,
    chartdashboard,
    PiechartComponent,
    NewnemberlinechartComponent,
    MemberrenewalslinechartComponent,
    MemberexpiredlinechartComponent,
    BooksaleslinechartComponent,
    RegisterstudentlinechartComponent,
    GraduatestudentlinechartComponent,
    TrafficlinechartComponent,
  },
  data() {
    return {
      permission: {},
      time1: null,
      StartDate: "",
      EndDate: "",
      trafficdialog: false,
      Graduatestudentdialog: false,
      NewMemberdialog: false,
      registerstudentdialog: false,
      memberrenewalsdialog: false,
      memberexpireddialog: false,
      tableLoader: false,
      booksaleseddialog: false,
      headers: [
        { text: "#", value: "index" },
        { text: "Page", value: "page" },
        { text: "Slug", value: "slug" },
        { text: "Visits", value: "visit" },
      ],
      dashboardDataTable: [],
      chartData: {
        labels: [
          "500 Starter",
          "400 Access",
          "500 Practitioner",
          "400 Standard",
          "500 Practitioner",
        ],
        datasets: [
          {
            data: [300, 500, 100, 300, 50],
            backgroundColor: [
              "#F4685F",
              "#EAA413",
              "#B4E722",
              "#0071BD",
              "#0071BD",
            ],
            hoverBackgroundColor: ["#64B5F6", "#81C784", "#FFB74D"],
          },
        ],
      },
      chartOptions: {
        legend: {
          labels: {
            fontColor: "#495057",
          },
        },
      },

      filterItem: [
        {
          text: "Today",
        },
        {
          text: "This week",
        },
        {
          text: "This month",
        },
        {
          text: "Previous month",
        },
        {
          text: "This year",
        },
        {
          text: "Previous year",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["GetUserRolePermissions"]),
  },
  mounted() {
    this.permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Dashboard"
    );
    this.tableLoader = true;
    setTimeout(() => {
      this.dashboardDataTable = [
        {
          index: 1,
          page: "title_page",
          slug: "/practitioner",
          visit: "789",
        },
        {
          index: 2,
          page: "Store",
          slug: "/store",
          visit: "789",
        },
        {
          index: 3,
          page: "LARQ Bottle Movement PureVis™",
          slug: "/larq-bottle-movement-purevis",
          visit: "789",
        },
        {
          index: 4,
          page: "title_page",
          slug: "/practitioner",
          visit: "789",
        },
      ];
      this.tableLoader = false;
    }, 1200);
  },
  methods: {
    check() { 
      var a = new Date();
      // var a = new Date(Date.now() - 864e5);  previoue date
      console.log(a.toString().substring(0, 15));
      var b = new Date(new Date(new Date().setDate(1)).toDateString());
      var end = new Date(
        new Date(
          new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0)
        ).toDateString()
      );
      console.log(
        b.toString().substring(0, 15) + " " + end.toString().substring(0, 15)
      );
    },
  },
};
</script>

<style scoped>
.table_style_one {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  /* identical to box height */

  /* Color/General/Black High Emphasis */

  color: #222222;
}
.table_style_two {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height */

  /* Color/General/Black High Emphasis */

  color: #222222;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: red !important;
}
/* .mx-datepicker-range {
  width: 14vw;
} */
.table-heading {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  color: #222222;
}
.h2 {
  font-family: "Nunito" !important;
  font-size: 24px;
  font-weight: 700;
  line-height: 33px;
  color: rgba(34, 34, 34, 1);
}
.card-h2 {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 28px;
}
.card_h1 {
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: rgba(34, 34, 34, 1);
}
.month_span {
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 600;
}
.pie_text {
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 600;
  color: #333333;
  margin-left: 1vw;
}
.pie_dot {
  border-radius: 100%;
}
.card_span_two {
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 600;
  color: #27ae60;
}
.card_span_one {
  font-family: "Nunito";
  font-size: 28px;
  font-weight: 600;
  color: #333333;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: white !important;
}
@media screen and (max-width: 1000px) {
  .col-md-3 {
    flex: 0 0 50%;
    max-width: 100%;
  }
}
@media screen and (max-width: 430px) {
  .col-md-3 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
.font--16 {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 28px;
  color: #333333;
}
</style>
